import Vue from 'vue';

export default Vue.observable({
  context: null,
  showContextSidenav: false,
  forecast: null,
});
